<template>
  <div>
    <!-- Main Topic -->
    <div>
      <label>Main topic</label>
      <BaseTextarea
        type="text"
        placeholder="es. alla scoperta di tesori nascosti ed esperienze autentiche"
        v-model="form.main_topic"
      />
    </div>

    <!-- Target -->
    <div class="row mt-2">
      <div class="col">
        <BaseInput
          label="Target"
          type="text"
          placeholder="Target"
          v-model="form.target"
        />
      </div>
    </div>

    <!-- Length -->
    <div class="row mt-2">
      <div class="col">
        <label>Lunghezza</label>
        <el-select
          :popper-append-to-body="false"
          class="select-primary"
          size="medium"
          v-model="form.length"
        >
          <el-option :value="50" label="Corto (circa 50 parole)" />
          <el-option :value="100" label="Medio (circa 100 parole)" />
          <el-option :value="200" label="Lungo (circa 200 parole)" />
        </el-select>
      </div>
    </div>

    <!-- Communication Goal -->
    <div class="row mt-2">
      <div class="col">
        <label>Comunication Goal</label>
        <el-select
          :popper-append-to-body="false"
          class="select-primary"
          size="medium"
          v-model="form.goal"
        >
          <el-option
            v-for="(option, index) in goalOptions"
            class="select-primary"
            :value="option.value"
            :label="option.name"
            :key="index"
          />
        </el-select>
      </div>
    </div>

    <!-- Brand Voice -->
    <div class="row mt-2">
      <div class="col">
        <BrandVoicesSelect
          :brand-voice-selected="form.brand_voice_id || null"
          @change="form.brand_voice_id = $event"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BaseInput, BaseTextarea } from 'src/components/index';
import { Select, Option } from 'element-ui';
import BrandVoicesSelect from 'src/pages/Tools/ToolsComponent/BrandVoicesSelect.vue';

export default {
  name: 'DemGeneratorInputsForm',
  components: {
    BaseInput,
    BaseTextarea,
    [Option.name]: Option,
    [Select.name]: Select,
    BrandVoicesSelect,
  },
  props: {
    jsonData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        main_topic: this.jsonData?.main_topic ?? '',
        target: this.jsonData?.target ?? '',
        length: this.jsonData?.length
          ? Number(this.jsonData.length)
          : 100,
        goal: this.jsonData?.goal ?? '',
        languages: this.jsonData?.languages ?? 'it',
        translate_from: this.jsonData?.translate_from ?? 'it',
        brand_voice_id: this.jsonData?.brand_voice_id ?? '',
      },
      goalOptions: [
        { value: 'informare', name: 'Informare' },
        { value: 'coinvolgere', name: 'Coinvolgere' },
        { value: 'convertire', name: 'Convertire' },
        { value: 'emozionare', name: 'Emozionare' },
      ],
    };
  },
  watch: {
    jsonData: {
      handler(newVal) {
        if (!newVal) return;
        this.form.main_topic = newVal.main_topic ?? '';
        this.form.target = newVal.target ?? '';
        this.form.length = newVal.length
          ? Number(newVal.length)
          : 100;
        this.form.goal = newVal.goal ?? '';
        this.form.languages = newVal.languages ?? 'it';
        this.form.translate_from = newVal.translate_from ?? 'it';
        this.form.brand_voice_id = newVal.brand_voice_id ?? '';
      },
      deep: true,
    },
    form: {
      handler() {
        this.$emit('update:formData', { ...this.form });
      },
      deep: true,
    },
  },
  mounted() {
    this.$emit('update:formData', { ...this.form });
  },
};
</script>
